import { Modal } from "antd";
import styled from "styled-components";
import bgSuccess from "../assets/images/img-popup-package-success.png";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import PATH from "../config/PATH";
import imgBtnBid from "../assets/images/Bid now button.svg";
import {
  ID_STATE_INTRO_TOUR,
  KEY_LOCAL_TOUR_COMPLETE,
  TYPE_USER,
  urlPageBid,
} from "../helper/const";
import iconAnimation from "../assets/images/icon-animation.png";
import AnimationFirework from "./AnimationFirework";
import { useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setReduxDataTypeIntroTour } from "../Redux/futures/home/actions";

const TOTAL_BID_FREE_A_DAY = 1;
function ModalNotifyByPackageSuccess({
  open,
  handleCancel,
  isModalFreeBid = false,
  message = "",
  dataSelect,
}) {
  const { typeIntroTour } = useSelector((state) => state.reducerHome);
  const dispatch = useDispatch();

  const location = useLocation();

  const [isShowAnimation, setIsShowAnimation] = useState(true);

  const navigate = useNavigate();

  const cancelPopup = () => {
    handleCancel();
    if (
      location.pathname === PATH.PACKAGE_DAILY &&
      typeIntroTour.typeActive === TYPE_USER.newDeeplink
    ) {
      dispatch(
        setReduxDataTypeIntroTour({
          typeActive: TYPE_USER.newDeeplink,
          step: 1,
        })
      );
    }
  };

  useEffect(() => {
    setIsShowAnimation(true);
  }, [open]);

  const handleToBid = () => {
    const isTourCompleted = localStorage.getItem(KEY_LOCAL_TOUR_COMPLETE);
    if (
      !isTourCompleted &&
      typeIntroTour.typeActive === TYPE_USER.newDeeplink
    ) {
      dispatch(
        setReduxDataTypeIntroTour({
          typeActive: TYPE_USER.newDeeplink,
          step: 2,
          page: `${PATH.BID}/${urlPageBid.running}`,
        })
      );
      navigate(`${PATH.BID}/${urlPageBid.running}`, {
        state: { idIntro: ID_STATE_INTRO_TOUR.newUser },
      });
    }
    handleCancel();
  };

  const onAfterOpen = (open) => {
    if (open) {
      const modalMask = document.querySelector(".ant-modal-mask");
      if (modalMask) {
        modalMask.classList.add("custom-modal-mask");
      }
    }
  };

  return (
    <ContainerModal
      bidTotal={TOTAL_BID_FREE_A_DAY}
      isModalFreeBid={isModalFreeBid}
      open={open}
      onCancel={cancelPopup}
      centered
      width={684}
      afterOpenChange={onAfterOpen}
    >
      <div
        className={`body-modal-success position-relative ${
          isModalFreeBid ? "modal-free-container" : ""
        }`}
      >
        {isShowAnimation || !isShowAnimation ? (
          <div
            className={`container-animation ${
              !isShowAnimation ? "cursor-default" : ""
            }`}
          >
            <div
              className={`position-relative ${
                !isShowAnimation ? "animation-hidden-item" : ""
              }`}
              onClick={handleToBid}
            >
              <AnimationFirework setIsShowAnimation={setIsShowAnimation} />
              <img src={iconAnimation} alt='' />
              <div className='total-bid'>
                {dataSelect ? dataSelect.max_turn : TOTAL_BID_FREE_A_DAY}
              </div>
            </div>
          </div>
        ) : null}
        <div className='position-relative'>
          <img src={bgSuccess} alt='background package success' />
        </div>
        <div className='content-modal-main text-center'>{message}</div>
        <div className='btn-action__package' onClick={handleToBid}>
          <img src={imgBtnBid} alt='' />
        </div>
      </div>
    </ContainerModal>
  );
}

const ContainerModal = styled(Modal)`
  .container-animation {
    position: absolute;
    z-index: 3;
    top: -75px;
    left: -70px;
    cursor: pointer;
  }

  .cursor-default {
    cursor: context-menu !important;
  }

  @keyframes shrinkAndFadeOut {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(0.5);
      opacity: 0;
      pointer-events: none;
    }
  }

  .animation-hidden-item {
    animation: shrinkAndFadeOut 1.5s ease forwards;
  }

  .total-bid {
    width: ${(props) => (props.bidTotal < 10 ? "34px" : "45px")};
    height: ${(props) => (props.bidTotal < 10 ? "34px" : "45px")};
    border-radius: 50%;
    background-color: red;
    border: 2px solid #ffff;
    color: white;
    font-size: ${(props) => (props.bidTotal > 99 ? "16px" : "20px")};
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    position: absolute;
    top: 25px;
    left: 37px;
    left: ${(props) => (props.bidTotal < 10 ? "37px" : "23px")};
  }

  .position-relative {
    position: relative;
  }

  .btn-action__package {
    cursor: pointer;
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);

    @media (min-width: 992px) {
      &:hover {
        opacity: 0.8;
        transition: 0.3s ease-in-out;
      }
    }
  }

  .text-center {
    text-align: center;
  }

  .content-modal-main {
    position: absolute;
    width: 100%;
    z-index: 2;
    color: #481d1d;
    font-size: 16px;
    padding: ${(props) => (props.isModalFreeBid ? "0 30px" : "0 55px;")};
    /* top: ${(props) => (props.isModalFreeBid ? "190px" : "215px")}; */
    top: 40% !important;
    transform: translateY(-50%) !important;
    div {
      font-weight: 600;
    }

    .first-content {
      padding-bottom: 15px;
    }
  }

  .ant-modal-content {
    background-color: inherit;
    box-shadow: inherit;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: max-content;
    max-width: 100%;
    margin: auto;
  }

  .ant-modal-footer {
    display: none;
  }

  .ant-modal-close svg {
    color: white;
    font-size: 22px;
  }

  @media (max-width: 992px) {
    .content-modal-main {
      padding: 0 15px;
      /* top: 31%; */
    }
  }

  @media (max-width: 768px) {
    .container-animation {
      left: 50%;
      transform: translateX(-50%);
      top: -66px;
      text-align: center;
      img {
        width: 80%;
      }

      .total-bid {
        font-size: ${(props) => (props.bidTotal > 99 ? "14px" : "16px")};
        width: ${(props) => (props.bidTotal < 10 ? "28px" : "35px")};
        height: ${(props) => (props.bidTotal < 10 ? "28px" : "35px")};
        left: ${(props) => (props.bidTotal < 10 ? "40px" : "32px")};
      }
    }
  }

  @media (max-width: 576px) {
    .modal-free-container {
      .content-modal-main {
        /* top: 25%; */
        font-size: 14px;
      }
    }
  }

  @media (max-height: 800px) {
    .container-animation {
      top: 0;
    }
  }
`;
export default ModalNotifyByPackageSuccess;
